import {RootState} from '@/store'
import {Module} from 'vuex'
import local from './modules/local'
import session from './modules/session'
import {StorageFilterState} from './types'

export {StorageFilterState}

const module: Module<StorageFilterState, RootState> = {
  namespaced: true,
  modules: {
    session,
    local,
  },
}

export default module
